import { Link } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { Building2, Stethoscope, HeartPulse, DollarSign, BarChart3, Share2 } from "lucide-react";
import { SEO } from "@/components/SEO";

export default function PartnersLanding() {
  return (
    <div className="min-h-screen bg-background">
      <SEO
        title="Programa de parcerias CareOS"
        description="Indique o CareOS para famílias e empresas de cuidados e ganhe comissão por cada assinatura ativada."
        canonical="https://careos.life/parceiros"
      />
      <header className="border-b">
        <div className="container mx-auto flex items-center justify-between py-4">
          <Link to="/" className="font-display text-xl font-bold text-primary">CareOS</Link>
          <div className="flex gap-2">
            <Button asChild variant="ghost"><Link to="/parceiros/painel">Já sou parceiro</Link></Button>
            <Button asChild><Link to="/parceiros/cadastro">Quero ser parceiro</Link></Button>
          </div>
        </div>
      </header>

      <section className="container mx-auto py-12 lg:py-20 text-center max-w-3xl">
        <h1 className="text-4xl lg:text-5xl font-display font-bold tracking-tight">
          Indique o CareOS e seja recompensado
        </h1>
        <p className="mt-6 text-lg text-muted-foreground">
          Farmácias, fisioterapeutas, médicos, enfermeiros e cuidadores: indique famílias
          que precisam de organização no cuidado e ganhe comissão por cada assinatura paga.
        </p>
        <div className="mt-8 flex justify-center gap-3">
          <Button size="lg" asChild><Link to="/parceiros/cadastro">Cadastrar agora</Link></Button>
          <Button size="lg" variant="outline" asChild><Link to="/parceiros/painel">Acessar painel</Link></Button>
        </div>
      </section>

      <section className="container mx-auto pb-16 grid gap-4 md:grid-cols-3">
        {[
          { icon: Share2, title: "Compartilhe seu link", desc: "Cada parceiro recebe um link único com seu código exclusivo." },
          { icon: BarChart3, title: "Acompanhe em tempo real", desc: "Veja cliques, cadastros e conversões pagas no painel." },
          { icon: DollarSign, title: "Receba por conversão", desc: "Cada nova assinatura paga gera bônus depositado via Pix." },
        ].map(({ icon: Icon, title, desc }) => (
          <Card key={title}>
            <CardHeader><Icon className="h-6 w-6 text-primary" /><CardTitle className="text-lg mt-2">{title}</CardTitle></CardHeader>
            <CardContent className="text-sm text-muted-foreground">{desc}</CardContent>
          </Card>
        ))}
      </section>

      <section className="container mx-auto pb-20 max-w-3xl">
        <h2 className="text-2xl font-bold mb-6 text-center">Para quem é?</h2>
        <div className="grid gap-4 md:grid-cols-3">
          {[
            { icon: Building2, label: "Farmácias e clínicas" },
            { icon: Stethoscope, label: "Profissionais de saúde" },
            { icon: HeartPulse, label: "Cuidadores autônomos" },
          ].map(({ icon: Icon, label }) => (
            <div key={label} className="flex items-center gap-3 rounded-lg border p-4">
              <Icon className="h-6 w-6 text-primary" />
              <span className="font-medium">{label}</span>
            </div>
          ))}
        </div>
      </section>
    </div>
  );
}
